'use client';

import React from 'react';
import { useState } from 'react';

export default function ContactSection() {

 
  const [form, setForm] = useState({ name: '', email: '', subject: '', message: '' });
  const [file, setFile] = useState<File | null>(null);

  const [status, setStatus] = useState('');

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setStatus('Sending...'); 
      const formEl = e.currentTarget;

    const formData = new FormData();
    formData.append('name', form.name);
    formData.append('email', form.email);
    formData.append('subject', form.subject);
    formData.append('message', form.message);
    if (file) formData.append('file', file); // send the file properly
    

     const res = await fetch("/api/send-email", {
      method: "POST",
      //headers: { "Content-Type": "application/json",Accept: "application/json" },
      //body: JSON.stringify(form),
      body: formData,
    });

    const data = await res.json();
    setStatus(data.message);  

    if (res.ok) {
      setForm({ name: '', email: '', subject: '', message: '' });
      formEl.reset();
      setFile(null);
    }
  };

  return (
    <section id="contact" className="contact section">
      {/* Section Title */}
      <div className="container section-title" data-aos="fade-up">
        <h2>Contact</h2>
        <p>Contact Us</p>
      </div>

      <div className="container" data-aos="fade-up" data-aos-delay="100">
        {/* Google Maps Embed */}
        <div className="mb-4" data-aos="fade-up" data-aos-delay="200">
          <iframe
            style={{ border: 0, width: '100%', height: '270px' }}
           //src="https://www.google.com/maps/embed?pb=!1m14!1m12!1m3!1d428.5491525524416!2d72.35211828908159!3d23.617111505956654!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!5e0!3m2!1sen!2sin!4v1752352005670!5m2!1sen!2sin"
            src="https://www.google.com/maps?q=F-14,+Saket+Business+Hub,+Radhanpur+Road,+Mehsana+-+384002&output=embed" 
            loading="lazy"
            allowFullScreen
            referrerPolicy="no-referrer-when-downgrade"
            title="Google Map"
          />
        </div>

        <div className="row gy-4">
          {/* Contact Info */}
          <div className="col-lg-4">
            <div className="info-item d-flex" data-aos="fade-up" data-aos-delay="300">
              <i className="bi bi-geo-alt flex-shrink-0"></i>
              <div>
                <h3>Address</h3>
                <p>F-14, Saket Business Hub,</p>
                <p>Radhanpur Road, Mehsana - 384002</p>
              </div>
            </div>

            <div className="info-item d-flex" data-aos="fade-up" data-aos-delay="400">
              <i className="bi bi-telephone flex-shrink-0"></i>
              <div>
                <h3>Call Us</h3>
                <p>+91 8320443494</p>
              </div>
            </div>

            <div className="info-item d-flex" data-aos="fade-up" data-aos-delay="500">
              <i className="bi bi-envelope flex-shrink-0"></i>
              <div>
                <h3>Email Us</h3>
                <p>info@smartservice.ind.in</p>
              </div>
            </div>
          </div>

          {/* Contact Form */}
          <div className="col-lg-8">
            <form
              onSubmit={handleSubmit}              
              className="php-email-form"
              data-aos="fade-up"
              data-aos-delay="200"
            >
              <div className="row gy-4">
                <div className="col-md-6">
                  <input
                    type="text"
                    name="name"
                     value={form.name}
        onChange={(e) => setForm({ ...form, name: e.target.value })}
                    className="form-control"
                    placeholder="Your Name"
                    required
                  />
                </div>

                <div className="col-md-6">
                  <input
                    type="email"
                    name="email"
                    value={form.email}
        onChange={(e) => setForm({ ...form, email: e.target.value })}
                    className="form-control"
                    placeholder="Your Email"
                    required
                  />
                </div>

                <div className="col-md-12">
                  <input
                    type="text"
                    name="subject"
                    value={form.subject}
        onChange={(e) => setForm({ ...form, subject: e.target.value })}
                    className="form-control"
                    placeholder="Subject"
                    required
                  />
                </div>

                <div className="col-md-12">
                  <textarea
                    name="message"
                    value={form.message}
        onChange={(e) => setForm({ ...form, message: e.target.value })}
                    className="form-control"
                    rows={6}
                    placeholder="Message"
                    required
                  ></textarea>
                </div>

                <div className="col-md-12">
                  <input
                   //key={file ? file.name : "file-input"}
                    name="file"
                    type="file"                    
       onChange={(e) => setFile(e.target.files?.[0] || null)}
                    className="form-control"                    
                    placeholder="file"                   
                  />
                </div>

                <div className="col-md-12 text-center">
                  <div className="loading">Loading</div>
                  <div className="error-message"></div>
                  <div className="sent-message">Your message has been sent. Thank you!</div>

                  <button type="submit">Send Message</button>
                   <p className="text-sm">{status}</p>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </section>
  ); 
}
